import React from 'react';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useIntl } from 'react-intl';

import { InputWrapper } from '@/components/input/InputBasic';
import { RegularText } from '@/components/text';

import InputPhoneField from './InputPhoneField';

const InputPhone = ({ control, name, label, placeholder }) => {
  const intl = useIntl();

  return (
    <>
      <Controller
        control={control}
        name={name}
        render={({ field, formState: { errors } }) => {
          return (
            <InputWrapper>
              <PhoneInput
                {...field}
                control={control}
                inputComponent={InputPhoneField}
                name={name}
                label={<RegularText id={label} fontSize="1.6rem" />}
                placeholder={intl.formatMessage({ id: placeholder })}
                error={!!errors['phone']}
                helperText={errors['phone']?.message}
                defaultCountry="KR"
                international={false}
              />
            </InputWrapper>
          );
        }}
      />
    </>
  );
};

export default InputPhone;
